/**
 * RESPONSIBILITY: draw the Visit page's body — its heading, then its sections, each as its template.
 *
 * THE TINT ALTERNATES BY POSITION among the sections actually drawn, so an editor changes
 * the rhythm by dragging a row, and a section with nothing to show never leaves two of the
 * same colour side by side. That is why each template is asked `has()` first, here.
 *
 * A section switched off is not drawn, for anybody; the switch is one row of the list the
 * pencil on this band opens, so it cannot be lost.
 */
import { idOf } from '@framework/core';
import type { VisitExpectSection } from '@app/sections';
import { isShown } from '../commons/shown';
import { visitBandOf } from './bands/bands';

export function VisitExpect({ c }: { c: VisitExpectSection }) {
  const bands = (c.bands ?? []).filter((b) => isShown(b) && visitBandOf(b)?.has(b));

  return (
    <>
      {(c.heading || c.intro) && (
        <section className="band band-centre visit-expect-head">
          <div className="wrap">
            {c.heading && <h2>{c.heading}</h2>}
            {c.intro && <p className="lede">{c.intro}</p>}
          </div>
        </section>
      )}
      {bands.map((band, i) => {
        const Draw = visitBandOf(band)!.Draw;
        return <Draw b={band} tinted={i % 2 === 0} key={idOf(band) || i} />;
      })}
    </>
  );
}
